import {
  BaseHeaderLinkDefinition,
  EntityModel,
  FilterCollection,
  GenericFieldValue,
  ShowFiltersDefinition,
  ViewAcl,
} from '@msdk/definitions'
import {
  ActionsContainer,
  ButtonIcon,
  ButtonScheleton,
  CardHeader as BaseCardHeader,
  createComponentWrapperWithRef,
  Divider as UiDivider,
  IconSelector,
  styled,
  uiTokens,
} from '@msdk/ui'
import React from 'react'

import { ViewActionButton } from '../../models/form/view-action-button'
import { Filters } from '../Filters'
import { ViewActions } from '../ViewActions'
import { ViewHeaderLinks } from '../ViewHeaderLinks'

type Props = {
  canBeCreated: boolean
  onCreate: () => void
  isInitialized: boolean
  customActions: ViewActionButton[]
  entityName: string
  viewName: string
  reload: () => Promise<void>
  currentFilters: Record<string, GenericFieldValue>
  acl: ViewAcl
  shouldShowDescription: boolean
  description: string
  showFilters: ShowFiltersDefinition
  filters: FilterCollection
  entityModel: EntityModel
  initialFilters?: Record<string, GenericFieldValue> | undefined
  isMultiselected: boolean
  filterChange: (filter: Record<string, GenericFieldValue>) => void
  setIsMultiselect: (value: boolean) => void
  headerLinks: BaseHeaderLinkDefinition[]
}

const NovaCardHeader = styled(BaseCardHeader)`
  .MuiCardHeader-title {
    color: ${uiTokens.uiContent.accent};
  }
`

const MuiCardHeader = styled(BaseCardHeader)`
  padding: 24px 32px 16px 24px;
  .MuiCardHeader-content {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }
`

const CardHeader = createComponentWrapperWithRef(
  {
    mui: MuiCardHeader,
    nova: NovaCardHeader,
  },
  'CardHeader',
)

const FiltersContainer = styled('div')`
  display: flex;
  padding-inline: 24px;
`

const Divider = createComponentWrapperWithRef(
  {
    mui: UiDivider,
    nova: React.Fragment,
  },
  'Divider',
)

const BaseEmbeddedViewHeader = ({
  canBeCreated,
  onCreate,
  isInitialized,
  customActions,
  entityName,
  viewName,
  reload,
  currentFilters,
  acl,
  shouldShowDescription,
  description,
  showFilters,
  filters,
  entityModel,
  initialFilters,
  filterChange,
  isMultiselected,
  setIsMultiselect,
  headerLinks,
}: Props) => (
  <>
    <CardHeader
      action={
        <ActionsContainer>
          {canBeCreated && (
            <ButtonIcon>
              <IconSelector iconName="Add" color="primary" onClick={onCreate} />
            </ButtonIcon>
          )}
          {!isInitialized && <ButtonScheleton />}
          {isInitialized && (
            <ViewActions
              actions={customActions}
              entityName={entityName}
              viewName={viewName}
              reload={reload}
              currentFilters={currentFilters}
              acl={acl}
            />
          )}
        </ActionsContainer>
      }
      title={shouldShowDescription && description}
      subheader={<ViewHeaderLinks links={headerLinks} reload={reload} />}
    />
    {showFilters === ShowFiltersDefinition.True && (
      <FiltersContainer>
        <Filters
          filters={filters}
          viewName={viewName}
          onFilterChange={filterChange}
          multiselect={isMultiselected}
          setMultiselect={setIsMultiselect}
          acl={acl}
          entityModel={entityModel}
          initialValues={initialFilters}
          hideBinnedItemsFilter={true}
        />
      </FiltersContainer>
    )}
    <Divider />
  </>
)

export const EmbeddedViewHeader = createComponentWrapperWithRef(
  {
    nova: BaseEmbeddedViewHeader,
    mui: BaseEmbeddedViewHeader,
    propsEnhancer: (props, lib) => {
      if (lib === 'nova') {
        props.headerLinks = []
      }
      return props
    },
  },
  'EmbeddedViewHeader',
)
